<template>
    <div class="scc-double-text-box">
        <div class="scc-double-text-box__title-container">
            <h2 class="scc-double-text-box__title">{{ title }}</h2>
        </div>
        <div class="scc-double-text-box__boxes">
            <div class="scc-double-text-box__left">
                <div class="scc-double-text-box__left-container">
                    <h3 class="scc-double-text-box__subtitle">{{ leftBoxTitle }}</h3>
                    <p class="scc-double-text-box__text">{{ leftBoxText }}</p>
                </div>
            </div>
            <div class="scc-double-text-box__right">
                <div class="scc-double-text-box__right-container">
                    <h3 class="scc-double-text-box__subtitle">
                        {{ rightBoxTitle }}
                    </h3>
                    <p class="scc-double-text-box__text">{{ rightBoxText }}</p>
                    <SccLink class="scc-double-text-box__button" :to="rightBoxButtonLink">
                        {{ rightBoxButtonText }}
                    </SccLink>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import './text-box-double.scss';
import SccLink from './SccLink';

export default {
    name: 'TextBoxDouble',
    components: { SccLink },
    props: {
        title: {
            type: String,
            default: 'Main title',
        },
        leftBoxTitle: {
            type: String,
            default: 'Left box Title',
        },
        leftBoxText: {
            type: String,
            default: 'Left box paragraph',
        },
        rightBoxTitle: {
            type: String,
            default: 'Right box title',
        },
        rightBoxText: {
            type: String,
            default: 'Right box paragraph',
        },
        rightBoxButtonLink: {
            type: String,
            default: 'trekkingsuitslag',
        },
        rightBoxButtonText: {
            type: String,
            default: 'Bekijk de trekkingsuitslag',
        },
    },
};
</script>
